__turbopack_context__.v({
  "black-bt": "Confirmation-module-scss-module__W__RkG__black-bt",
  "btnCustom": "Confirmation-module-scss-module__W__RkG__btnCustom",
  "confirmationBody": "Confirmation-module-scss-module__W__RkG__confirmationBody",
  "confirmationPopup": "Confirmation-module-scss-module__W__RkG__confirmationPopup",
  "error": "Confirmation-module-scss-module__W__RkG__error",
  "formGroup": "Confirmation-module-scss-module__W__RkG__formGroup",
  "icon": "Confirmation-module-scss-module__W__RkG__icon",
  "success": "Confirmation-module-scss-module__W__RkG__success",
  "warning": "Confirmation-module-scss-module__W__RkG__warning",
});
